/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CaretBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M3.67 6.978a.569.569 0 010-.81.582.582 0 01.817 0L8 9.673l3.513-3.503a.582.582 0 01.818 0 .57.57 0 010 .81l-3.839 3.815a.712.712 0 01-.912.076l-.091-.077-3.82-3.815zm9.28 5.972a7.002 7.002 0 000-9.9 7.002 7.002 0 00-9.9 0 7.002 7.002 0 000 9.9 7.002 7.002 0 009.9 0z"
        />
    </AccessibleSVG>
);

export default CaretBadge16;
